import { render, staticRenderFns } from "./Favorite.vue?vue&type=template&id=f77417a0&scoped=true&"
import script from "./Favorite.vue?vue&type=script&lang=ts&"
export * from "./Favorite.vue?vue&type=script&lang=ts&"
import style0 from "./Favorite.vue?vue&type=style&index=0&id=f77417a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77417a0",
  null
  
)

export default component.exports